// extracted by mini-css-extract-plugin
export default {"personal":"About_personal__YB6WW","professional":"About_professional__hxM6u"};